/**
 * Ligatures typographiques françaises : œ = oe, æ = ae.
 * NFKD ne les décompose pas de façon fiable (œ reste U+0153).
 */
export function foldFrenchLigatures(value) {
  return String(value || "")
    .replace(/œ/g, "oe")
    .replace(/Œ/g, "OE")
    .replace(/æ/g, "ae")
    .replace(/Æ/g, "AE");
}

/** Comparaison d'une réponse tapée : casse ignorée, accents conservés, œ/ae pliées. */
export function normalizeForTypedAnswer(value) {
  return foldFrenchLigatures(String(value || "").trim()).toLocaleLowerCase("fr-FR");
}

export function typedAnswersMatch(expected, given) {
  return normalizeForTypedAnswer(expected) === normalizeForTypedAnswer(given);
}
